import React, { useEffect, useState } from "react";
import { Typography, TextField, Box } from "@mui/material";
import apiClient from "../utils/apiClient";
import CropTypeToggle from "../components/CropTypeToggle";
import CropsTable from "../components/CropsTable";
import { useCropFilter } from "../hooks/useCropFilter";
import { useCropColumns } from "../hooks/useCropColumns";
import "../style/Crops.css";

/**
 * Main Crops page component
 * Orchestrates data fetching, filtering, and rendering
 */
const Crops = () => {
  const [crops, setCrops] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCropType, setSelectedCropType] = useState('vegetable');

  // Fetch crops on mount
  useEffect(() => {
    const fetchCrops = async () => {
      try {
        const response = await apiClient.get("/crops");
        setCrops(response.data);
      } catch (err) {
        console.error("Failed to fetch crops:", err);
      }
    };

    fetchCrops();
  }, []);

  // Business logic hooks
  const filteredCrops = useCropFilter(crops, selectedCropType, searchQuery);
  const columns = useCropColumns(crops, selectedCropType);

  return (
    <Box>
      <Typography 
        variant="h3" 
        gutterBottom 
        className="vintage-script-header"
      >
        Crop Types
      </Typography>

      <CropTypeToggle
        selectedCropType={selectedCropType}
        onCropTypeChange={setSelectedCropType}
      />

      <TextField
        fullWidth
        label="Search Crops"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search by name, type, or Latin name"
        variant="outlined"
        margin="normal"
        className="crop-search-field"
      />

      <CropsTable crops={filteredCrops} columns={columns} />
    </Box>
  );
};

export default Crops;
